import { FPUtils } from './FloatingPointUtils';

export class FormUtils {
  static preventNegativeCurrencyInput(e) {
    if (e.key === '-' || e.key === 'Subtract' || e.keyCode === 189 || e.keyCode === 109) {
      e.preventDefault();
    }
  }

  static toSafeNumber(value) {
    const n = Number(value);
    return Number.isFinite(n) ? FPUtils.round2dec(n) : 0;
  }

  static allowOnlyNumericInput(e) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Enter', 'Home', 'End'];
    const isControlKey = e.ctrlKey || e.metaKey || e.altKey;
    const isDigit = /^[0-9]$/.test(e.key);

    if (isDigit || allowedKeys.includes(e.key) || isControlKey) {
      return;
    }

    e.preventDefault();
  }

  static onlyNumberKeypress(e) {
    const char = String.fromCharCode(e.which || e.key || e.keyCode);
    if (!/[0-9]/.test(char)) e.preventDefault();
  }

  static trimMax(value, max = 100) {
    return String(value || '').trim().slice(0, max);
  }
}
